import { Button, Checkbox, Divider, Form, Input, Row, Spin } from "antd";
import React from "react";
import UsersService from "../../../Services/UsersService";
import { reportType } from "./UsersDetailsTabs";
import { notification } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const ReportSecurity = ({ userId }: any) => {
  const [form] = Form.useForm();
  const [btnLoading, setBtnLoading] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    getUserDataById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const getUserDataById = async () => {
    setLoading(true);
    let res = await UsersService?.getUserDataById(userId);
    if (res) {
      const voucherAccessList = res?.result?.accessSettings?.reportsAccessList;
      const formattedData = voucherAccessList?.map((item: any) => ({
        reportName: reportType[item?.reportName],
        allowToView: item?.allowToView,
        allowToPrint: item?.allowToPrint,
      }));

      form.setFieldsValue({
        items: formattedData,
      });
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const saveBasicDetailsData = () => {
    setBtnLoading(true);
    form.validateFields().then(async (val: any) => {
      console.log("val", val);
      let data = val?.items.map((itm: any) => {
        let reco = {
          reportName: reportType.indexOf(itm?.reportName),
          allowToView: itm?.allowToView,
          allowToPrint: itm?.allowToPrint,
        };
        return reco;
      });

      let res = await UsersService?.UpdateUserDetailsData(
        userId,
        { AccessSettings: { ReportsAccessList: [...data] } },
        2
      );
      if (res?.status === true) {
        console.log("res", res);
        setBtnLoading(false);
        getUserDataById();
        notification.success({
          message: "Success",
          description: "User details updated successfully.",
        });
      } else {
        notification.error({
          message: "Error",
          description: res?.message,
        });
      }
    });
  };
  return (
    <div style={{ marginLeft: "15px" }}>
      <Divider
        orientation="left"
        orientationMargin={0}
        style={{ margin: "7px 0px 14px 0px" }}
      >
        Report Security
      </Divider>
      <Spin indicator={<LoadingOutlined />} spinning={loading}>
        <Form
          form={form}
          labelAlign="left"
          layout="vertical"
          requiredMark={false}
          initialValues={{
            items: [{}],
          }}
        >
          <table
            // border="1"
            // cellPadding="10"
            // cellSpacing="0"
            className="AddPageTabelDesign"
            style={{ width: "50%" }}
          >
            <thead>
              <tr>
                <th>Report Name</th>
                <th>Allow To Print</th>
                <th>Allow To View</th>
              </tr>
            </thead>
            <tbody>
              <Form.List name="items">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <tr key={key}>
                        <td>
                          <Form.Item
                            className="m-0"
                            {...restField}
                            name={[name, "reportName"]}
                            rules={[
                              {
                                required: true,
                                message: "Missing voucher type",
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <Form.Item
                            className="m-0"
                            {...restField}
                            name={[name, "allowToPrint"]}
                            valuePropName="checked"
                            rules={[
                              {
                                required: true,
                                message: "Missing add/edit info",
                              },
                            ]}
                          >
                            <Checkbox />
                          </Form.Item>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <Form.Item
                            className="m-0"
                            {...restField}
                            name={[name, "allowToView"]}
                            valuePropName="checked"
                            rules={[
                              {
                                required: true,
                                message: "Missing delete info",
                              },
                            ]}
                          >
                            <Checkbox />
                          </Form.Item>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </Form.List>
            </tbody>
          </table>
          <Row
            style={{ margin: "10px 10px", marginRight: "117px" }}
            justify={"center"}
          >
            <Button
              loading={btnLoading}
              type="primary"
              style={{ padding: "4px 30px" }}
              onClick={saveBasicDetailsData}
            >
              Update
            </Button>
          </Row>
        </Form>
      </Spin>
    </div>
  );
};

export default ReportSecurity;
